import { useState } from "react";
import { socialLinks } from "../style_palete";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50"> 
      <div className="absolute inset-0 bg-[#E6F5FF]/20 backdrop-blur-sm">
        <div className="absolute -inset-2 bg-gradient-to-r from-[#2E8BC0]/10 to-[#2BB5A3]/10 rounded-2xl blur-sm"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 md:px-6 h-16 border border-[#8FD3FE]/40 flex items-center justify-between backdrop-blur-md bg-white/70 rounded-b-2xl transition hover:bg-white/90">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <img 
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhFmorPDGVUU8g88S9g-fjXqwrNzMnbD2OGQ&s" 
          alt="Kalmares BA"
          className="h-10 w-10 rounded-full shadow-md object-cover"
        />
        
        <span className="font-semibold tracking-wide text-[#0F1B2D]">
          Kalmares BA
        </span>
      </div>

        
          {/* nav */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
            {[
              ["#servicios","Especialidades"],
              ["#Promociones","Promociones"],
              ["#equipo","Equipo"],
              ["#obras-sociales","Obras Sociales"],
              ["#contacto","Contacto"],
            ]
            .map(([href,label]) => (
              <a 
                key={href} 
                href={href}
                className="group relative py-1 text-[#0F1B2D]/90 hover:text-[#2E8BC0] transition-colors"
              >
                {label}
                <span className="absolute left-0 -bottom-0.5 h-[2px] w-full origin-left scale-x-0 bg-gradient-to-r from-[#2E8BC0] via-[#2BB5A3] to-[#2E8BC0] transition-transform duration-300 group-hover:scale-x-100"></span>
              </a>
            ))}
          </nav>

          {/* acciones */}
          <div className="hidden md:flex items-center gap-3">
            <a 
              href={socialLinks.instagram} 
              target="_blank" 
              rel="noreferrer"
              className="rounded-full px-3 py-2 text-sm border border-[#8FD3FE]/80 text-[#0F1B2D]/90 hover:text-[#2E8BC0] hover:bg-white/90 transition"
            >
              Instagram
            </a>
            <a 
              href={socialLinks.whatsapp} 
              target="_blank" 
              rel="noreferrer"
              className="rounded-full px-4 py-2 text-sm font-semibold text-white shadow-md hover:shadow-lg hover:scale-[1.03] active:scale-[0.98] transition"
              style={{ background: "linear-gradient(135deg, #2E8BC0, #2BB5A3)" }}
            >
              Reservar
            </a>
          </div>

        {/* menú móvil */}
        <button 
          className="md:hidden rounded-xl border border-[#8FD3FE] px-3 py-2 text-[#0F1B2D]"
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>
      </div>

      {/* menú móvil */}
      {open && (
        <div className="md:hidden border-t border-[#8FD3FE]/60 bg-white/95 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-2">
            {/* CAMBIO: text-[#0F1B2D] y hover azul */}
            <a href="#servicios" className="py-2 text-[#0F1B2D] hover:text-[#2E8BC0] font-medium">Especialidades</a>
            <a href="#Promociones" className="py-2 text-[#0F1B2D] hover:text-[#2E8BC0] font-medium">Promociones</a>
            <a href="#equipo" className="py-2 text-[#0F1B2D] hover:text-[#2E8BC0] font-medium">Equipo</a>
            <a href="#obras-sociales" className="py-2 text-[#0F1B2D] hover:text-[#2E8BC0] font-medium">
              Obras Sociales</a>
            <a href="#contacto" className="py-2 text-[#0F1B2D] hover:text-[#2E8BC0] font-medium">Contacto</a>
            <div className="flex gap-2 pt-2">
              <a href={socialLinks.instagram} target="_blank" rel="noreferrer" 
                 className="flex-1 rounded-xl border border-[#8FD3FE] px-4 py-2 text-center text-[#0F1B2D] hover:text-[#2E8BC0] hover:bg-white/90">
                Instagram
              </a>
              <a href={socialLinks.whatsapp} target="_blank" rel="noreferrer"
                 className="flex-1 rounded-xl px-4 py-2 text-center font-semibold text-white shadow"
                 style={{ background: "linear-gradient(135deg, #2E8BC0, #2BB5A3)" }}>
                Reservar
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}